import { MuiPickersOverrides } from '@material-ui/pickers/typings/overrides'
import { createMuiTheme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import colors from '../../shared/constants/colors'

type overridesNameToClassKey = {
  [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P]
}

declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey extends overridesNameToClassKey {}
}

export const materialDatePickerTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: `${colors.primary}`,
        padding: 0,
      },
    },

    MuiPickersToolbarButton: {
      toolbarBtn: {
        padding: '0px !important',
      },
    },

    MuiPickersDay: {
      day: {
        color: `${colors.primary}`,
      },
      daySelected: {
        backgroundColor: `${colors.primary}`,
        color: `${colors.paroEggshell}`,
      },
      dayDisabled: {
        color: `${colors.disabled}`,
      },
      current: {
        color: `${colors.primary}`,
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: `${colors.primary}`,
      },
    },

    MuiTypography: {
      subtitle1: {
        fontSize: '1.5rem',
      },
    },

    MuiPickersYear: {
      yearSelected: {
        color: `${colors.paroEggshell}`,
        backgroundColor: `${colors.primary}`,
      },
    },
  },
})

export const useTextFieldStyles = makeStyles({
  root: {
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: `${colors.darkGray} !important`,
    },
  },
  input: {
    color: `${colors.darkGray}`,
  },
})
